console.log('Consent handler loaded');

const MAX_WAIT_TIME = 10000; // 10 seconds
const MAX_RETRIES = 2; // Maximum number of retries
const RETRY_INTERVAL = 200; // 200 milliseconds

const pollUntil = (conditionFunction, onSuccess, onFailure, timeout = MAX_WAIT_TIME) => {
	const startTime = Date.now();
	const interval = setInterval(() => {
    console.log('Polling for condition...');
		if (conditionFunction()) {
			clearInterval(interval);
			onSuccess();
		} else if (Date.now() - startTime > timeout) {
			clearInterval(interval);
			console.error('Timeout reached while waiting for condition');
			if (onFailure) {
				onFailure();
			}
		}
	}, RETRY_INTERVAL);
};

const publishEventToShopifyFromParam = (param) => {
	const eventName = 'post:paramsDataId';
	const eventData = {
		event: eventName,
		data: param,
	};
	pollUntil(
		() => window.Shopify && window.Shopify.analytics,
		() => {
			window.Shopify.analytics.publish(eventName, eventData);
			console.log('Shopify object is available, event published:', eventName, eventData);
		},
		() => {
			console.error('Failed to publish event to Shopify after retries');
		},
	);
};

const setShopifyConsentFromParam = (consentParam) => {
	try {
		const consentDecoded = JSON.parse(atob(consentParam));
		// map functional to preferences
		consentDecoded.preferences = consentDecoded.functional;
		const consentData = {
			analytics: consentDecoded.analytics === true,
			marketing: consentDecoded.marketing === true,
			preferences: consentDecoded.preferences === true,
		};
		console.log('Parsed consent data:', consentData);
		pollUntil(
			() => window.Shopify && typeof window.Shopify.customerPrivacy === 'object',
			() => {
				window.Shopify.customerPrivacy.setTrackingConsent(consentData, () => {
					console.log('Consent set via URL param');
				});
				setTimeout(() => {
					window.location.reload();
				}, 350);
			},
			() => {
				console.error('Failed to set consent data after retries customer privacy not found');
			},
		);
	} catch (error) {
		console.error('Error parsing consent data:', error);
	}
};

document.addEventListener('consent:params', function (event) {
	// event.detail contains the consentParam
	console.log('Consent param event received:', event.detail);

	const urlParams = event.detail.params;
	const consentParam = urlParams.get('consentData');
	// marketing technology params
	const paramIDs = ['gbraid', 'wbraid', 'gclid', 'fbclid', 'utm_source', 'everID'];
	const idParamFound = paramIDs.find((param) => urlParams.has(param));
	if (idParamFound) {
		const param = {
			name: idParamFound,
			value: urlParams.get(idParamFound),
		};
		publishEventToShopifyFromParam(param);
	} else {
		console.log('No marketing param found');
	}

  if (consentParam) {
    console.log('Consent param found:', consentParam);
    pollUntil(
      () => window.Shopify && typeof window.Shopify.loadFeatures === 'function',
      () => {
        console.log('Shopify consent API is available');
        window.Shopify.loadFeatures([
          {
            name: 'consent-tracking-api',
            version: '0.1',
            onError: (error) => {
              console.error('Error loading consent-tracking feature:', error);
            },
          },
        ]);
        setShopifyConsentFromParam(consentParam);
      },
      () => {
        console.error('Failed to load Shopify consent API after retries');
      },
    );
  }
});

document.addEventListener('visitorConsentCollected', (event) => console.log('Consent set', event.detail));
